import { removeCookie } from 'js/utils/cookie.util';
import { getLang, getBaseDomain } from 'js/utils/url.util';
import { languageService } from 'js/services/language.service';

export const getCookiesList = (cookieGroups = [], cookiesStorageData = {}) => {
    const cookiesArray = cookieGroups
        .filter((item) => item.enabled && !cookiesStorageData[item.group] && Boolean(item.names))
        .map((item) => item.names);

    return cookiesArray.length
        ? cookiesArray.join(',').split(',')
            .map(cookie => cookie.trim())
        : cookiesArray;
};

export const clearCookies = (cookiesList) => cookiesList.forEach((cookie) => {
    const lang = getLang();

    if (lang) {
        const { getTwoLetterLanguage, aliasLocaleMapping } = languageService;
        const hrefLang = aliasLocaleMapping[lang] || getTwoLetterLanguage(lang);

        removeCookie(cookie, { path: `/${hrefLang}` });
        removeCookie(cookie, { path: `/${hrefLang}`, domain: getBaseDomain() });
    }

    removeCookie(cookie, { path: '/' });
    removeCookie(cookie, { path: '/', domain: getBaseDomain() });
});

export const parseCookiesGroups = (cookiesData = []) =>
    cookiesData.reduce((obj, item) => item.enabled && item.group !== 'system'
            ? { ...obj, [item.group]: false }
            : obj,
        {});

export const prepareCookiesGroups = (defaultGroups, storageGroups) =>
    Object.keys(defaultGroups).reduce((acc, key) => ({
        ...acc,
        [key]: typeof storageGroups[key] === 'boolean' ? storageGroups[key] : defaultGroups[key]
    }), {});
